<template>
  <div class="core-columns">
    <TheContent
      v-for="item of elem.children"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '../../TheContent';

  export default defineNuxtComponent({
    name: 'CoreColumns',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .core-columns {
    display: flex;

    width: 100%;
    flex-wrap: wrap;
    gap: 24px;
    margin: 24px 0;

    :deep() {
      :first-child {
        margin: 0;
      }
    }

    @include mobile {
      flex-wrap: nowrap;
      gap: 12px;
    }
  }
</style>
